<template>
  <section class="projects" id="projects">
    <AppProjectsBlock :projects="projects" />
    <div class="container">
      <AppButton class="projects__btn-show-all" theme="dark" to="/projects">
        Смотреть все проекты
      </AppButton>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'

import AppButton from '@/components/ui/AppButton/Index.vue'
import AppProjectsBlock from '@/components/global/AppProjectsBlock/Index.vue'

import ProjectsService from '@/services/ProjectsService'
import { IProject } from '@/types/Projects'

export default defineComponent({
  name: 'OurProjects',
  components: { AppButton, AppProjectsBlock },
  setup() {
    const projects = ref<IProject[]>([])

    onMounted(async () => {
      const res = await ProjectsService.fetchAll()
      projects.value = [...res].slice(0, 3)
    })

    return { projects }
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
